/**
 * @param {Object} props
 * @param {boolean} props.condition
 * @param {Object} props.wrapper
 */
const ConditionalActionWrapper = ({ condition, wrapper, children }) =>
  condition ? wrapper(children) : children;

export default ConditionalActionWrapper;
